// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Select, Text, Stack } from '@mantine/core';
import { i18n } from '@lingui/core';
import { useContext } from 'react';
import { IconChevronDown } from '@tabler/icons';
import { ContractContext } from '../../../Service/Context/ContractContextV2';
import { DataS } from '../../../Service/DataS';
import { ContractSign, CustomerSignType } from '../../../Types/DocumentT';
import SkeletonItems from '../../../Atoms/SkeletonItems';

const ContractSignatureSection = () => {
  const { loading, contract, savePatch } = useContext(ContractContext);
  const { contractSign, customerSignType } = contract ?? {};

  return (
    <>
      <Text weight="bolder" size="lg" mb="md" mt="md">
        Unterschrift
      </Text>
      <Text mb="md">Definieren Sie, wie die Signatur angezeigt/erfasst werden soll</Text>
      {loading && <SkeletonItems height={40} count={2} />}
      {!loading && (
        <Stack sx={{ maxWidth: 600 }}>
          <Select
            value={contractSign}
            label={i18n._('contract.sign')}
            data={DataS.getContractSignOptions(i18n)}
            onChange={(val: ContractSign) => savePatch({ contractSign: val })}
            styles={{ rightSection: { pointerEvents: 'none' } }}
            rightSection={<IconChevronDown size={14} />}
            rightSectionWidth={25}
          />
          <Select
            disabled={contractSign === 'NONE'}
            value={customerSignType}
            label={i18n._('contract.sign.type')}
            data={DataS.getCustomerSignTypeOptions(i18n)}
            onChange={(val: CustomerSignType) => savePatch({ customerSignType: val })}
            styles={{ rightSection: { pointerEvents: 'none' } }}
            rightSection={<IconChevronDown size={14} />}
            rightSectionWidth={25}
          />
        </Stack>
      )}
    </>
  );
};

export default ContractSignatureSection;
